import React from 'react';
import { Box } from '@mui/material';

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`exit-request-tabpanel-${index}`}
      aria-labelledby={`exit-request-tab-${index}`}
      style={{
        height: '100%',
        display: value === index ? 'block' : 'none'
      }}
      {...other}
    >
      {value === index && (
        <Box sx={{
          height: '100%',
          overflowY: 'auto',  // Only show scrollbar when needed
          overflowX: 'hidden' // Hide horizontal scrollbar
        }}>
          {children}
        </Box>
      )}
    </div>
  );
};
